import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type JobSummaryState = {
  // NOTE : this is really `jobSummariesByOrgId` since a "JobSummary" is a type constructed
  // on the backend, and doesn't have its own id. To use our utilities, though, this name
  // is what we have to use.
  jobSummariesById: { [orgId: number]: { [jobId: number]: JobSummary } };
  jobSummariesStateByOrgId: StateDictionary;
  jobTitlesById: { [orgId: number]: Array<JobTitleSummary> };
  jobTitlesStateByOrgId: StateDictionary;
};
type State = { jobSummaries: JobSummaryState };

const jobSummariesByIdSelector = (state: State) => state.jobSummaries.jobSummariesById;

export const jobSummariesForOrgIdSelector = createSelector(
  [jobSummariesByIdSelector, (_state: State, orgId: number) => orgId],
  (jobSummaries, orgId) => jobSummaries[orgId],
);

export const jobSummariesForJobIdSelector = createSelector(
  [jobSummariesByIdSelector, (_state: State, jobId: number) => jobId],
  (jobSummaries, jobId) =>
    Object.values(jobSummaries)
      .flatMap((jobSummariesForOrg) => Object.values(jobSummariesForOrg))
      .filter((jobSummary) => jobSummary.jobId === jobId),
);

const jobSummariesStateByOrgIdSelector = (state: State) =>
  state.jobSummaries.jobSummariesStateByOrgId;
export const jobSummariesStateForOrgIdSelector = createSelector(
  [jobSummariesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (jobSummariesStateByOrgId, orgId) => jobSummariesStateByOrgId[orgId],
);

const jobTitlesByIdSelector = (state: State) => state.jobSummaries.jobTitlesById;

export const jobTitlesForOrgIdSelector = createSelector(
  [jobTitlesByIdSelector, (_state: State, orgId: number) => orgId],
  (jobTitles, orgId) => jobTitles[orgId],
);

export const jobTitlesStateByOrgIdSelector = (state: State) =>
  state.jobSummaries.jobTitlesStateByOrgId;
export const jobTitlesStateForOrgIdSelector = createSelector(
  [jobTitlesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (jobTitlesStateByOrgId, orgId) => jobTitlesStateByOrgId[orgId],
);
